export const fr = {
  // Navigation
  nav: {
    dashboard: 'Tableau de bord',
    profile: 'Profil',
    signOut: 'Déconnexion',
    settings: 'Paramètres',
  },

  // Dashboard
  dashboard: {
    welcome: 'Bon retour',
    welcomeSubtext: 'Gérez vos événements et connectez-vous avec vos amis',
    calendar: 'Calendrier',
    createEvent: 'Créer un Événement',
    yourEvents: 'Vos Événements',
    manageEvents: 'Gérez et suivez tous vos événements',
    searchEvents: 'Rechercher des événements...',
    filter: {
      all: 'Tous les Événements',
      hosting: 'Organisation',
      attending: 'Participation',
    },
    stats: {
      totalEvents: 'Total des Événements',
      hosting: 'Organisation',
      attending: 'Participation',
    },
    noEvents: 'Aucun événement pour le moment',
    noEventsFound: 'Aucun événement trouvé',
    noEventsDescription: 'Créez votre premier événement pour commencer et rassembler les gens !',
    noEventsFoundDescription: 'Essayez d\'ajuster vos critères de recherche ou de filtrage.',
    loading: 'Chargement de votre tableau de bord...',
    syncingProfile: 'Synchronisation de vos informations de profil...',
  },

  // Event Tile
  eventTile: {
    host: 'Hôte',
    upcoming: 'À venir',
    past: 'Passé',
    attending: 'participant',
    manageEvent: 'Gérer l\'Événement',
    daysOfWeek: {
      Sun: 'Dim',
      Mon: 'Lun',
      Tue: 'Mar',
      Wed: 'Mer',
      Thu: 'Jeu',
      Fri: 'Ven',
      Sat: 'Sam',
    },
    monthsShort: {
      Jan: 'Jan',
      Feb: 'Fév',
      Mar: 'Mar',
      Apr: 'Avr',
      May: 'Mai',
      Jun: 'Juin',
      Jul: 'Juil',
      Aug: 'Août',
      Sep: 'Sep',
      Oct: 'Oct',
      Nov: 'Nov',
      Dec: 'Déc',
    },
  },

  // Calendar
  calendar: {
    upcomingEvents: 'Événements À Venir',
    hosting: 'Organisation',
    attending: 'Participation',
    event: 'événement',
    events: 'événements',
    more: 'plus',
    daysShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
  },

  // Event Dashboard
  event: {
    tasks: 'Tâches',
    expenses: 'Dépenses',
    attendees: 'Participants',
    seeWhosComing: 'Voir qui vient à votre événement',
    shareEvent: 'Partager l\'Événement',
    locationNotSpecified: 'Emplacement non spécifié',
    loadingEvent: 'Chargement de l\'événement...',
    loadingProfile: 'Chargement de votre profil...',
    back: 'Retour',
    loadingAttendees: 'Chargement des participants...',
    personGoing: 'Personne Participant',
    peopleGoing: 'Personnes Participant',
    host: 'Hôte',
    eventHost: 'Hôte de l\'Événement',
    attendee: 'Participant',
    noAttendeesYet: 'Aucun participant pour le moment',
    shareEventInvite: 'Partagez le lien de votre événement pour inviter des personnes et les voir apparaître ici.',
    pageOf: 'sur',
  },

  // Event Data
  eventData: {
    host: 'Hôte',
    joinEvent: 'Rejoindre l\'Événement',
    leaveEvent: 'Quitter l\'Événement',
    editEvent: 'Modifier l\'Événement',
    deleteEvent: 'Supprimer l\'Événement',
    shareLink: 'Partager le Lien',
    linkCopied: 'Lien de l\'événement copié dans le presse-papiers !',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet événement ?',
    deleteWarning: 'Cette action ne peut pas être annulée.',
    cancel: 'Annuler',
    delete: 'Supprimer',
    youreTheHost: 'Vous êtes l\'Hôte',
    personAttending: 'personne participant',
    peopleAttending: 'personnes participant',
    aboutThisEvent: 'À propos de cet événement',
    location: 'Lieu',
    tags: 'Étiquettes',
    eventParticipation: 'Participation à l\'Événement',
    shareEvent: 'Partager l\'Événement',
    hostActions: 'Actions de l\'Hôte',
    upcomingEvent: 'Événement À Venir',
    pastEvent: 'Événement Passé',
    eventStatistics: 'Statistiques de l\'Événement',
    totalAttendees: 'Total des Participants',
    eventStatus: 'Statut de l\'Événement',
    upcoming: 'À venir',
    completed: 'Terminé',
    timeUntilEvent: 'Temps Avant l\'Événement',
  },

  // Share Event Modal
  shareModal: {
    shareEvent: 'Partager l\'Événement',
    shareThisEvent: 'Partager cet événement',
    copyLink: 'Copier le Lien',
    linkCopied: 'Lien copié !',
    copyLinkTitle: 'Copier le lien',
    joinMyEvent: 'Rejoignez mon événement',
    checkOutThisEvent: 'Découvrez cet événement',
    email: 'Email',
    whatsapp: 'WhatsApp',
    twitter: 'Twitter',
    facebook: 'Facebook',
  },

  // Edit Event Modal
  editModal: {
    editEvent: 'Modifier l\'Événement',
    updateEventDetails: 'Mettez à jour les détails de votre événement',
    eventName: 'Nom de l\'Événement',
    eventNamePlaceholder: 'ex., Fête d\'Anniversaire d\'Anna',
    dateTime: 'Date et Heure',
    selectDateTime: 'Sélectionnez la date et l\'heure',
    location: 'Lieu',
    locationPlaceholder: 'ex., 123 Rue Arc-en-ciel, Ville',
    description: 'Description',
    descriptionPlaceholder: 'Dites aux gens à quoi s\'attendre à votre événement...',
    eventImage: 'Image de l\'Événement',
    eventPreview: 'Aperçu de l\'événement',
    clickToUpload: 'Cliquez pour télécharger l\'image de l\'événement',
    updateEvent: 'Mettre à Jour l\'Événement',
    updatingEvent: 'Mise à Jour de l\'Événement...',
    required: '*',
  },

  // Delete Event Modal
  deleteModal: {
    deleteEvent: 'Supprimer l\'Événement',
    cannotBeUndone: 'Cette action ne peut pas être annulée',
    deleteEventTitle: 'Supprimer "{title}" ?',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet événement ?',
    dataWillBeRemoved: 'Toutes les données de l\'événement, tâches et dépenses seront supprimées définitivement.',
    friendsWillBeSad: 'Vos amis seront tristes 😔',
    cancel: 'Annuler',
    deleting: 'Suppression...',
    errorDeleting: 'Erreur lors de la suppression de l\'événement.',
  },

  // Create Event Form
  createEvent: {
    title: 'Créer un Nouvel Événement',
    subtitle: 'Rassemblez les gens',
    hostEvent: 'Organiser un Événement',
    eventTitle: 'Titre de l\'Événement',
    eventTitlePlaceholder: 'Entrez le titre de l\'événement',
    eventName: 'Nom de l\'Événement',
    eventNamePlaceholder: 'ex., Fête d\'Anniversaire d\'Anna',
    description: 'Description',
    descriptionPlaceholder: 'Décrivez votre événement',
    descriptionPlaceholderLong: 'Dites aux gens à quoi s\'attendre lors de votre événement...',
    location: 'Lieu',
    locationPlaceholder: 'Où se déroule votre événement ?',
    locationPlaceholderLong: 'ex., 123 Rue Arc-en-ciel, Ville',
    date: 'Date',
    time: 'Heure',
    dateTime: 'Date et Heure',
    selectDateTime: 'Sélectionner la date et l\'heure',
    eventImage: 'Image de l\'Événement',
    uploadImage: 'Télécharger une Image',
    clickToUpload: 'Cliquez pour télécharger l\'image de l\'événement',
    browseFiles: 'parcourir',
    dragAndDrop: 'Glissez et déposez une image ici, ou',
    imageRequirements: 'JPG, PNG ou GIF (Max 5MB)',
    cancel: 'Annuler',
    create: 'Créer l\'Événement',
    creating: 'Création...',
    creatingEvent: 'Création de l\'Événement...',
    eventCreatedSuccess: 'Événement créé avec succès !',
    requiredField: '*',
    userIdentificationError: 'Impossible d\'identifier l\'utilisateur. Veuillez actualiser la page et réessayer.',
  },

  // Expenses
  expenses: {
    title: 'Dépenses de l\'Événement',
    addExpense: 'Ajouter une Dépense',
    description: 'Description',
    amount: 'Montant',
    paidBy: 'Payé par',
    actions: 'Actions',
    noExpenses: 'Aucune dépense pour le moment',
    noExpensesDescription: 'Commencez à suivre les dépenses de cet événement',
    paymentBalance: 'Solde des Paiements',
    totalExpenses: 'Dépenses Totales',
    perPerson: 'Par Personne',
    youOwe: 'Vous devez',
    owesYou: 'vous doit',
    settledUp: 'Réglé !',
    paid: 'Payé',
    balance: 'Solde',
    suggestedPayments: 'Paiements Suggérés',
    pays: 'paie',
    descriptionPlaceholder: 'À quoi servait cette dépense ?',
    amountPlaceholder: 'Montant',
    selectPayer: 'Sélectionnez qui a payé',
    trackAndManage: 'Suivre et gérer les coûts de l\'événement',
    averageExpense: 'Dépense Moyenne',
    totalItems: 'Total des Articles',
    expenseHistory: 'Historique des Dépenses',
    spendingBreakdown: 'Répartition des Dépenses',
    settlementDescription: 'Qui doit de l\'argent et à qui on en doit',
    splitEqually: 'Partager équitablement entre',
    attendee: 'participant',
    attendees: 'participants',
    everyonePaid: 'Tout le monde a payé sa juste part',
    to: 'à',
    settleBalancesInstruction: 'Pour régler tous les soldes, effectuez ces paiements:',
  },

  // Settings
  settings: {
    title: 'Paramètres',
    currency: 'Devise',
    language: 'Langue',
    theme: 'Thème',
    lightTheme: 'Clair',
    darkTheme: 'Sombre',
    saveChanges: 'Enregistrer les Modifications',
    cancel: 'Annuler',
    currencies: {
      usd: 'Dollar Américain',
      eur: 'Euro',
      gbp: 'Livre Sterling',
    },
    languages: {
      english: 'English',
      spanish: 'Español',
      french: 'Français',
    },
  },

  // Profile
  profile: {
    title: 'Paramètres du Profil',
    subtitle: 'Gérez les informations et préférences de votre compte',
    personalInfo: 'Informations Personnelles',
    security: 'Sécurité',
    fullName: 'Nom Complet',
    phoneNumber: 'Numéro de Téléphone',
    emailAddress: 'Adresse Email',
    profilePicture: 'Photo de Profil',
    uploadPhoto: 'Télécharger une Photo',
    uploading: 'Téléchargement...',
    photoInfo: 'JPG, PNG ou GIF. Taille maximale de 5MB.',
    currentPassword: 'Mot de Passe Actuel',
    newPassword: 'Nouveau Mot de Passe',
    confirmPassword: 'Confirmer le Nouveau Mot de Passe',
    passwordStrength: 'Force du Mot de Passe',
    saveChanges: 'Enregistrer les Modifications',
    saving: 'Enregistrement...',
    profileUpdated: 'Profil mis à jour avec succès !',
    namePlaceholder: 'Entrez votre nom complet',
    phonePlaceholder: 'Entrez votre numéro de téléphone',
    emailPlaceholder: 'Entrez votre adresse email',
    currentPasswordPlaceholder: 'Entrez le mot de passe actuel pour changer',
    newPasswordPlaceholder: 'Entrez le nouveau mot de passe',
    confirmPasswordPlaceholder: 'Confirmez le nouveau mot de passe',
    backToDashboard: 'Retour au Tableau de Bord',
    loadingProfile: 'Chargement du profil...',
    userDataNotLoaded: 'Données utilisateur non chargées. Veuillez actualiser la page.',
    passwordsDoNotMatch: 'Les nouveaux mots de passe ne correspondent pas',
    passwordTooWeak: 'Le mot de passe est trop faible. Veuillez utiliser un mot de passe plus fort.',
    noChangesToSave: 'Aucune modification à enregistrer.',
    emailAlreadyInUse: 'Cet email est déjà utilisé par un autre compte.',
    updateError: 'Échec de la mise à jour du profil. Veuillez réessayer.',
    generalError: 'Une erreur s\'est produite lors de la mise à jour de votre profil.',
    uploadImageError: 'Échec du téléchargement de l\'image',
    updateProfilePicError: 'Échec de la mise à jour de la photo de profil',
    retryUpload: 'Échec du téléchargement de l\'image. Veuillez réessayer.',
  },

  // Tasks/Todos
  tasks: {
    title: 'Tâches de l\'Événement',
    subtitle: 'Organisez et suivez les tâches de votre événement',
    addNewTask: 'Ajouter une nouvelle tâche',
    pendingCompleted: '{pending} en attente, {completed} terminées',
    loadingTasks: 'Chargement des tâches...',
    enterTaskDescription: 'Entrez la description de la tâche...',
    pendingTasks: 'Tâches en Attente',
    completedTasks: 'Tâches Terminées',
    noPendingTasks: 'Aucune tâche en attente',
    noCompletedTasks: 'Aucune tâche terminée pour le moment',
    progressOverview: 'Aperçu du Progrès',
    tasksCompleted: '{completed} sur {total} tâches terminées',
    remaining: '{remaining} restantes',
    completed: 'Terminée',
    markAsIncomplete: 'Marquer comme incomplète',
  },

  // Common
  common: {
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    close: 'Fermer',
    confirm: 'Confirmer',
    back: 'Retour',
    next: 'Suivant',
    submit: 'Soumettre',
    search: 'Rechercher',
    filter: 'Filtrer',
    sort: 'Trier',
    refresh: 'Actualiser',
    add: 'Ajouter',
    remove: 'Retirer',
    yes: 'Oui',
    no: 'Non',
    altText: {
      profile: 'Profil',
      eventPreview: 'Aperçu de l\'événement',
    },
  },
};